import React from 'react';

type UserDetailsType = {
  userId: string;
  instId: string;
  accountId: string;
  email: string;
  firstname: string;
  lastname: string;
  role: string;
  groupId: string;
  accountType: string;
  apitoken: any;
};

const UserDetailsContext = React.createContext<Partial<UserDetailsType>>({});

export const UserDetailsProvider = UserDetailsContext.Provider;
export const UserDetailsConsumer = UserDetailsContext.Consumer;
export default UserDetailsContext;
